import { userSelectorEnTranslations } from './user-selector.en';
import { userSelectorHeTranslations } from './user-selector.he';

export const userSelectorTranslations = {
  en: userSelectorEnTranslations,
  he: userSelectorHeTranslations,
} as const;
